'use client';

import { useEffect, useState } from 'react';

export default function Print({ print }: { print: boolean }) {
  const [prevPrint, setPrevPrint] = useState(false);

  useEffect(() => {
    if (print && !prevPrint) {
      window.print();
      setPrevPrint(true);
    }
  }, [print, prevPrint]);

  return null;
}
